import React, { useEffect } from "react";
import RootModel from "../models/RootModel/RootModel";
import { getUserTopics } from "../services/tweetService";
import { useQuery } from "react-query";
import Tweet from "../components/Tweet/Tweet";
import SimpleSpinner from "../components/Loader/SimpleSpinner";

const ProfilePage = () => {
  const { isLoading, data, error } = useQuery(
    "user-topic",
    () => getUserTopics(),
    {
      refetchOnWindowFocus: false,
      cacheTime: 0,
      // onSuccess: bindChannel,
      staleTime: 0,
    }
  );
  return (
    <div>
      <RootModel>
        {isLoading ? (
          <SimpleSpinner />
        ) : (
          <>
            {data?.topics_with_state?.length > 0 && (
              <h2
                style={{
                  color: "#fff",
                  marginBottom: "1rem",
                  marginTop: "1rem",
                }}
              >
                قرارات الولاية
              </h2>
            )}
            {data &&
              data?.topics_with_state.map((tweet) => (
                <Tweet className={"margins"} tweet={tweet} key={tweet.id} />
              ))}

            {data?.topics_with_locality?.length > 0 && (
              <h2
                style={{
                  color: "#fff",
                  marginBottom: "1rem",
                  marginTop: "1rem",
                }}
              >
                قرارات المحلية
              </h2>
            )}
            {data &&
              data?.topics_with_locality.map((tweet) => (
                <Tweet className={"margins"} tweet={tweet} key={tweet.id} />
              ))}
          </>
        )}
        {error && <p className="error error-text">{error}</p>}
      </RootModel>
    </div>
  );
};

export default ProfilePage;
